import type { Palette, PaletteColor, Theme } from '@mui/material'

import type { CSSObject } from '@mui/material/styles'

export const resolveThemeColor = <T extends Theme>(
  theme: T,
  color: 'primary' | 'secondary' | 'error' | 'info' | 'inherit' | 'success' | 'warning' | 'default' | undefined,
  variant: keyof PaletteColor = 'main',
  transform?: (value: string) => string,
) => {
  if (!color || color === 'inherit') {
    return 'inherit'
  }

  const themeColour = theme.palette[color as keyof Palette] as PaletteColor

  return transform ? transform(themeColour[variant]) : themeColour[variant]
}

export interface SlideAwayOptions {
  collapsed: boolean
  /** The page edge the panel sits against, and leaves by */
  direction: 'left' | 'right'
}

/** Slides a panel off the page edge it sits against, and back, keeping its size; its contents leave the tab order once it has gone */
export const slideAway = (theme: Theme, { collapsed, direction }: SlideAwayOptions): CSSObject => {
  const duration = theme.transitions.duration.enteringScreen

  return {
    transform: collapsed ? `translateX(${direction === 'left' ? '-100%' : '100%'})` : 'none',
    visibility: collapsed ? 'hidden' : 'visible',
    transition: `${theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration,
    })}, visibility 0s linear ${collapsed ? duration : 0}ms`,
  }
}
